"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTableCellLayout_unstable", {
    enumerable: true,
    get: ()=>useTableCellLayout_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _tableContext = require("../../contexts/tableContext");
const tableAvatarSizeMap = {
    medium: 32,
    small: 24,
    'extra-small': 20
};
const useTableCellLayout_unstable = (props, ref)=>{
    const { size  } = (0, _tableContext.useTableContext)();
    return {
        components: {
            root: 'div',
            main: 'span',
            description: 'span',
            content: 'div',
            media: 'span'
        },
        root: (0, _reactUtilities.getNativeElementProps)('div', {
            ref,
            ...props
        }),
        appearance: props.appearance,
        truncate: props.truncate,
        main: (0, _reactUtilities.resolveShorthand)(props.main, {
            required: true
        }),
        media: (0, _reactUtilities.resolveShorthand)(props.media),
        description: (0, _reactUtilities.resolveShorthand)(props.description),
        content: (0, _reactUtilities.resolveShorthand)(props.content, {
            required: !!props.description || !!props.children
        }),
        avatarSize: tableAvatarSizeMap[size],
        size
    };
}; //# sourceMappingURL=useTableCellLayout.js.map

//# sourceMappingURL=useTableCellLayout.js.map